@if ({
  facetList: facetList$ | async,
  }; as content) {
  @if (content.facetList?.activeFacets && content.facetList?.activeFacets?.length) {
    <div class="simple-card cx-active-facets-inner">
      <div id="cx-active-facets-groupName" class="title">
        {{ 'productList.appliedFilter' | cxTranslate }}
      </div>
      @for (facet of content.facetList!?.activeFacets; track facet) {
        <a
          routerLink="./"
          [queryParams]="getLinkParams(facet)"
          [cxFocus]="{ key: getFocusKey(content.facetList!, facet) }"
          role="button"
          (keydown.space)="removeFilterWithSpacebar($event)"
          [attr.aria-label]="'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }"
          >
          <span>{{ facet.facetValueName }}</span>
          <cx-icon aria-hidden="true" [type]="closeIcon"></cx-icon>
        </a>
      }
    </div>
  }
}
